import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { StoreServiceModule } from '@ddt-web/store-service';
import { UrlModule } from '@ddt-web/url';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { DataPortfolioAnalysisService, DataUserDataService, StoreServiceHelper } from './api';
import { ErrorComponent, LoadingComponent, SimpleRowRepeatingSkeletonComponent } from './component';
import { DefaultTemplateComponent } from './component/default-template';
import { AutoScrollerDirective, DisplayTabDataDirective, ShowOnlyInViewDirective, ViewDataDirective } from './directives';
import { CellFormattedValuePipe } from './pipes/cell-formatted-value.pipe';
import { ProductUrlPipe } from './pipes/product-url.pipe';
import { TabSelectorPipe } from './pipes/tab-selector.pipe';
import { AudienceService, DisplayDataFactoryService, ViewDataFactoryService } from './services';

@NgModule({
	declarations: [
		LoadingComponent,
		ErrorComponent,
		ViewDataDirective,
		AutoScrollerDirective,
		ShowOnlyInViewDirective,
		DisplayTabDataDirective,
		ErrorComponent,
		LoadingComponent,
		DefaultTemplateComponent,
		SimpleRowRepeatingSkeletonComponent,
		ProductUrlPipe,
		CellFormattedValuePipe,
		TabSelectorPipe
	],
	imports: [
		StoreServiceModule,
		CommonModule,
		CwpNgFrameworkModule,
		NgxSkeletonLoaderModule,
		UrlModule,
		DzProgressSpinnerModule
	],
	exports: [
		ViewDataDirective,
		ShowOnlyInViewDirective,
		DisplayTabDataDirective,
		AutoScrollerDirective,
		SimpleRowRepeatingSkeletonComponent,
		LoadingComponent,
		ProductUrlPipe,
		CellFormattedValuePipe,
		TabSelectorPipe
	]
})
export class DataServiceModule {
	public static forRoot(): ModuleWithProviders<DataServiceModule> {
		return {
			ngModule: DataServiceModule,
			providers: [
				DataPortfolioAnalysisService,
				ViewDataFactoryService,
				DisplayDataFactoryService,
				DataUserDataService,
				StoreServiceHelper,
				AudienceService
			]
		};
	}
}
